import { render, staticRenderFns } from "./GameItemsEditUploadFile.vue?vue&type=template&id=2229de66&scoped=true&"
import script from "./GameItemsEditUploadFile.vue?vue&type=script&lang=js&"
export * from "./GameItemsEditUploadFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2229de66",
  null
  
)

export default component.exports